import { Checkbox, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Autocomplete, MenuItem } from "@mui/material";
import React, { useLayoutEffect } from "react";
import { useState, useEffect, useRef } from "react";
import moment from "moment";
import { checkVCF, getTank, postConversion, saveKT0406 } from "../../../services/api";
import { saveKT0401, saveKT0407 } from "../../../services/api";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { sumOfField } from "../../../services/libService";
import { useTranslation } from "react-i18next";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

export default function TicketForm({ code, data, printRef, editButtonRef, ticketid, onUpdateSuccess, ticketData }) {
  switch (code) {
    case "BM.QT.KT.04.01":
      return <BMQTKT0401 onUpdateSuccess={onUpdateSuccess} printRef={printRef} data={data} ticketid={ticketid} ticketData={ticketData} />;
    case "BM.QT.KT.04.06":
      return <BMQTKT0406 onUpdateSuccess={onUpdateSuccess} printRef={printRef} data={data[0]} ticketid={ticketid} ticketData={ticketData} />;
    case "BM.QT.KT.04.07":
      return <BMQTKT0407 onUpdateSuccess={onUpdateSuccess} printRef={printRef} data={data[0]} ticketid={ticketid} ticketData={ticketData} />;
    default:
      return "No form found";
  }
}
export function BMQTKT0401({ data, printRef, ticketid, onUpdateSuccess, ticketData }) {
  // form BM.QT.KT.04.01
  // custom hook
  const [t] = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const localDataRef = useRef(); //newest localData

  // redux state
  const user = useSelector((state) => state.user.data);

  // state
  // const ticketData = useContext(ticketData)
  const [isEdit, setIsEdit] = useState(false);
  const [tankData, setTankData] = useState([]);
  const [localData, setLocalData] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const saveable = !isEdit
    ? true
    : Boolean(
        localData[0].rc_certificate &&
          localData[0].rc_batch &&
          localData[0].rc_d15 &&
          localData[0].trc_d15 &&
          localData[0].sc_drain &&
          localData[0].sc_appearance &&
          localData[0].sc_density &&
          localData[0].sc_temperature &&
          localData[0].sc_d15 &&
          localData[0].conductivity &&
          localData[0].imp_tanks !== "[]"
      );

  // methods
  const handleChange = (keyName, value) => {
    //main
    setLocalData((prev) =>
      prev.map((item) => ({
        ...item,
        [keyName]: value,
      }))
    );

    switch (keyName) {
      case "sc_density":
        handleChange("sc_d15", "");
        handleChange("sc_vcf", "");
        handleChange("sc_wcf", "");
        if (value >= 0.701 && value <= 0.873 && localDataRef.current[0].sc_temperature >= 4.5 && localDataRef.current[0].sc_temperature <= 52) {
          // converting
          postConversion({
            quantity: 0,
            unit: 21,
            method: 1,
            temp: localDataRef.current[0].sc_temperature,
            density: value,
          }).then((res) => {
            if (res.code !== 200) return;
            if (value === localDataRef.current[0][keyName]) {
              // neu day la convert moi nhat thi moi thay doi state
              handleChange("sc_d15", res.data.d15);
              handleChange("sc_vcf", res.data.vcf);
              handleChange("sc_wcf", res.data.wcf);
            } else {
            }
          });
        }
        break;
      case "sc_temperature":
        handleChange("sc_d15", "");
        handleChange("sc_d15", "");
        handleChange("sc_d15", "");
        handleChange("sc_d15", "");
        handleChange("sc_vcf", "");
        handleChange("sc_wcf", "");
        if (localDataRef.current[0].sc_density >= 0.701 && localDataRef.current[0].sc_density <= 0.873 && value >= 4.5 && value <= 52) {
          // converting
          postConversion({
            quantity: 0,
            unit: 21,
            method: 1,
            temp: value,
            density: localDataRef.current[0].sc_density,
          }).then((res) => {
            if (res.code !== 200) return;
            if (value === localDataRef.current[0][keyName]) {
              // neu day la convert moi nhat thi moi thay doi state
              handleChange("sc_d15", res.data.d15);
              handleChange("sc_vcf", res.data.vcf);
              handleChange("sc_wcf", res.data.wcf);
            } else {
            }
          });
        }

        break;
      default:
        return;
    }
  };
  const handleSave = () => {
    // saving
    if (isEdit) {
      setIsSaving(true);
      saveKT0401(localData[0].id, {
        data: localData.map((item) => ({
          ...item,
          transaction_id: ticketid,
          date: moment(item.date || Date.now()).format("YYYY-MM-DD HH:mm"),
          gap_l15: (item.sc_d15 - item.trc_d15).toFixed(4),
          imp_tanks: JSON.parse(item.imp_tanks),
        })),
      }).then((res) => {
        if (res.code === 200) {
          setIsEdit(false);
          onUpdateSuccess && onUpdateSuccess();
        }
        setIsSaving(false);
        enqueueSnackbar(res.message, { variant: res.code === 200 ? "success" : "" });
      });
    }
    //editing
    else setIsEdit(true);
  };

  // effect
  useEffect(() => {
    localDataRef.current = localData;
  }, [localData]);
  useEffect(() => {
    setLocalData(data);
    data[0].imp_inventory_id && getTank({ inventory_id: data[0].imp_inventory_id }).then((res) => res.code === 200 && setTankData(res.data));
  }, [data]);
  useEffect(() => {
    if (!user || !isEdit) return;
    handleChange("checker", user.name, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isEdit]);

  if (data && localData)
    return (
      <div>
        <div ref={printRef} style={{ margin: "auto", padding: "30px 50px", wordWrap: "break-word" }}>
          <style type="text/css" media="print">
            {" @page { size: A4 landscape; } "}
            {" body { zoom: 80% } "}
          </style>
          <div style={{ height: 80, display: "flex", border: "1px solid gray" }}>
            <div style={{ width: "25%", display: "flex" }}>
              <img alt="" style={{ margin: "auto", width: "100%", height: 46, objectFit: "contain" }} src="/logoP3.png" />
            </div>
            <div style={{ width: "55%", borderLeft: "1px solid gray", display: "flex" }}>
              <div style={{ height: "40%", margin: "auto" }}>
                <b style={{ textTransform: "uppercase" }}>{localData[0].name}</b>
                <br />
              </div>
            </div>
            <div align="left" style={{ width: "20%", borderLeft: "1px solid gray", paddingLeft: 10 }}>
              Mã số:
              {localData[0].code}
              <br />
              Lần ban hành: {localData[0].version}
              <br />
              Ngày hiệu lực: {localData[0].effective_date}
            </div>
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Ngày
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Giờ
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Số xe
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} colSpan={3}>
                    Chứng chỉ xuất hàng
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }}>
                    Chứng chỉ bồn xuất
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} colSpan={6}>
                    Kiểm tra chất lượng mẫu xả đáy phương tiện
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Chênh lệch tỉ trọng giữa (7) và (13)
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Độ dẫn điện
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Bồn nhập
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={3}>
                    Người kiểm tra
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Số chứng chỉ
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Lô số
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Tỉ trọng ở 15°C
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Tỉ trọng ở 15°C
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Lần xả thứ
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Ngoại quan
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} rowSpan={2}>
                    Thử nước
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }} colSpan={3}>
                    Kiểm tra tỉ trọng
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" style={{ border: "1px solid gray" }}>
                    Tỉ trọng thực tế
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }}>
                    Nhiệt độ
                  </TableCell>
                  <TableCell align="center" style={{ border: "1px solid gray" }}>
                    Tỉ trọng ở 15°C
                  </TableCell>
                </TableRow>
                <TableRow>
                  {[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map((_, index) => (
                    <TableCell key={index} style={{ border: "1px solid gray" }}>
                      ({index + 1})
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {localData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" style={{ border: "1px solid gray", borderRight: isEdit ? "none" : "1px solid gray" }} colSpan={isEdit ? 2 : 1}>
                      {isEdit ? (
                        <CustomDatePicker
                          format="DD/MM/YYYY HH:mm"
                          outputFormat="YYYY-MM-DD HH:mm"
                          slotProps={{ textField: { variant: "standard" } }}
                          sx={{ minWidth: "180px" }}
                          value={moment(item.date || Date.now()).format("YYYY-MM-DD[T]HH:mm")}
                          onChange={(value) => handleChange("date", value, index)}
                        />
                      ) : (
                        item.date && moment(item.date).format("DD/MM/YYYY")
                      )}
                    </TableCell>
                    {!isEdit && (
                      <TableCell align="center" style={{ border: "1px solid gray", borderLeft: isEdit ? "none" : "1px solid gray" }}>
                        {item.date && moment(item.date).format("HH:mm")}
                      </TableCell>
                    )}
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {item.vehicle}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          value={item.rc_certificate || ""}
                          onChange={(e) => handleChange("rc_certificate", e.target.value, index)}
                        />
                      ) : (
                        item.rc_certificate
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          value={item.rc_batch || ""}
                          onChange={(e) => handleChange("rc_batch", e.target.value, index)}
                        />
                      ) : (
                        item.rc_batch
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          type="number"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          value={Math.round(item.rc_d15 * 10000)}
                          onChange={(e) => handleChange("rc_d15", e.target.value / 10000, index)}
                        />
                      ) : (
                        item.rc_d15 && parseFloat(item.rc_d15).toFixed(4)
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          type="number"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          value={Math.round(item.trc_d15 * 10000)}
                          onChange={(e) => handleChange("trc_d15", e.target.value / 10000, index)}
                        />
                      ) : (
                        item.trc_d15 && parseFloat(item.trc_d15).toFixed(4)
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField variant="standard" select value={item.sc_drain || ""} name="sc_drain" style={{ width: "70px" }} onChange={(e) => handleChange("sc_drain", e.target.value, index)}>
                          <MenuItem value="1"> 1</MenuItem>
                          <MenuItem value="2"> 2</MenuItem>
                          <MenuItem value="3"> 3</MenuItem>
                        </TextField>
                      ) : (
                        item.sc_drain
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      <Checkbox checked={Boolean(item.sc_appearance)} disabled={!isEdit} type="checkbox" onChange={() => handleChange("sc_appearance", item.sc_appearance ? 0 : 1, index)} />
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      <Checkbox checked={Boolean(item.sc_swd)} disabled={!isEdit} type="checkbox" onChange={() => handleChange("sc_swd", item.sc_swd ? 0 : 1, index)} />
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          error={Boolean(item.sc_density && Boolean(item.sc_density > 0.873 || item.sc_density < 0.701))}
                          style={{ width: 100 }}
                          type="number"
                          value={Math.round(item.sc_density * 10000) || ""}
                          onChange={(e) => handleChange("sc_density", e.target.value / 10000, index)}
                        />
                      ) : item.sc_density ? (
                        parseFloat(item.sc_density).toFixed(4)
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          error={Boolean(item.sc_temperature && Boolean(item.sc_temperature > 52 || item.sc_temperature < 4.5))}
                          style={{ width: 100 }}
                          type="number"
                          value={item.sc_temperature || ""}
                          onChange={(e) => handleChange("sc_temperature", e.target.value, index)}
                        />
                      ) : item.sc_temperature ? (
                        parseFloat(item.sc_temperature)?.toFixed(2)
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {parseFloat(+item.sc_d15)?.toFixed(4)}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {parseFloat(+item.sc_d15 - +item.trc_d15)?.toFixed(4)}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <TextField
                          variant="standard"
                          inputProps={{ style: { width: 100, textAlign: "center" } }}
                          value={item.conductivity || ""}
                          onChange={(e) => handleChange("conductivity", e.target.value, index)}
                        />
                      ) : (
                        item.conductivity
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {isEdit ? (
                        <Autocomplete
                          multiple
                          // filterSelectedOptions={true}
                          value={Array.isArray(JSON.parse(item.imp_tanks)) ? JSON.parse(item.imp_tanks) : []}
                          onChange={(e, newValue) => handleChange("imp_tanks", JSON.stringify(newValue), index)}
                          options={tankData || []}
                          sx={{ width: "200px" }}
                          getOptionLabel={(option) => (option ? option.code : "")}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          renderInput={(params) => <TextField variant="standard" {...params} size="small" />}
                        />
                      ) : (
                        // item.imp_tanks
                        item.imp_tanks &&
                        JSON.parse(item.imp_tanks) &&
                        JSON.parse(item.imp_tanks)
                          .map?.((sub_item) => sub_item.code)
                          .join(", ")
                      )}
                    </TableCell>
                    <TableCell align="center" style={{ border: "1px solid gray" }}>
                      {item.checker}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Button disabled={isSaving || !saveable} onClick={handleSave} variant="outlined">
          {t(!isEdit ? "Chỉnh sửa" : "Lưu")}
        </Button>
      </div>
    );
  else return "";
}

export function BMQTKT0406({ data, printRef, ticketid, onUpdateSuccess, ticketData }) {
  // form BM.QT.KT.04.06
  // const ticketData = useContext(ticketData)
  const form01Data = ticketData.forms["BM.QT.KT.04.01"]?.[0];
  const editable = !form01Data
    ? true
    : Boolean(
        form01Data.date &&
          form01Data.vehicle &&
          form01Data.rc_certificate &&
          form01Data.rc_batch &&
          form01Data.rc_d15 &&
          form01Data.trc_d15 &&
          form01Data.sc_drain &&
          form01Data.sc_appearance &&
          form01Data.sc_density &&
          form01Data.sc_temperature &&
          form01Data.sc_d15 &&
          form01Data.conductivity &&
          form01Data.imp_tanks !== "null"
      );
  const isHydrant = !Object.values(JSON.parse(ticketData.receipt.process)?.IMPORT || {})[0]; // true nghia la k co form 01
  const useSpecialSum = isHydrant && !JSON.parse(ticketData.receipt.process)?.["BM.QT.KT.04.06"]?.["CAL_BY_SUM_ROW"];

  const [isEdit, setIsEdit] = useState(false);
  const [localData, setLocalData] = useState("");
  const localDataRef = useRef();
  // const totalImpL15 = Math.round(!useSpecialSum ? sumOfField(localData?.sample, 'l15') : sumOfField(localData?.sample, 'ltt') * (localData?.sample || '')[0]?.vcf)
  useEffect(() => {
    localDataRef.current = localData;
  }, [localData]);
  const handleChange = (keyName, value) => {
    setLocalData((prev) => ({ ...prev, [keyName]: value }));
  };
  const editSample = (index, keyName, value) => {
    let newSample = localData.sample;
    newSample[index][keyName] = value;
    switch (keyName) {
      case "temperature":
        newSample[index].temp_error = !value || parseFloat(newSample[index].temperature) < 4.5 || parseFloat(newSample[index].temperature) > 52 ? "Temp must be in range 4.5 - 52" : undefined;
        if (!isHydrant) newSample[index].vcf = undefined;
        newSample[index].l15 = undefined;
        newSample[index].kg = undefined;
        newSample[index].wcf = undefined;
        if (!newSample[index].temp_error && localData.d15?.toString()) {
          checkVCF({ d15: localData.d15, temp: value }).then((res) => {
            if (res.code === 200 && localDataRef.current.sample[index].temperature === value) {
              newSample = localDataRef.current.sample;
              if (!isHydrant) newSample[index].vcf = res.data.vcf;
              newSample[index].vcf = (+newSample[index].vcf)?.toFixed(4);
              newSample[index].wcf = res.data.wcf?.toFixed(4);
              newSample[index].l15 = Math.round(newSample[index].vcf * newSample[index].ltt);
              newSample[index].kg = Math.round(newSample[index].wcf * newSample[index].l15);
              setLocalData((prev) => ({ ...prev, sample: newSample, imp_l15: Math.round(!useSpecialSum ? sumOfField(newSample, "l15") : sumOfField(newSample, "ltt") * (newSample || "")[0]?.vcf) }));
            }
          });
        }
        break;
      case "height":
        // console.log(newSample[index]);
        // newSample[index].ltt = (parseFloat(newSample[index].lit) + (parseFloat(newSample[index].edge_chk_hole)/10) - parseFloat(value)/10 * parseFloat(newSample[index].barem) * parseFloat(newSample[index].sub_tanks))
        // ltt = lit + sub_tank * barem * height / 10
        // console.log(`ltt = ${parseFloat(newSample[index].lit)} + ${parseFloat(newSample[index].sub_tanks)} * ${parseFloat(newSample[index].barem)} * ${value / 10}`);
        newSample[index].ltt = Math.round(parseFloat(newSample[index].lit) + (newSample[index].sub_tanks * parseFloat(newSample[index].barem) * value) / 10);
        // l15 = vcf * ltt
        newSample[index].l15 = Math.round(parseFloat(newSample[index].vcf) * parseFloat(newSample[index].ltt));
        newSample[index].kg = Math.round(newSample[index].wcf * newSample[index].l15);
        break;
      case "vcf":
        // console.log(newSample[index]);
        newSample[index].l15 = Math.round(parseFloat(newSample[index].vcf) * parseFloat(newSample[index].ltt));
        newSample[index].kg = Math.round(newSample[index].wcf * newSample[index].l15);
        break;
      default:
        break;
    }

    setLocalData((prev) => ({
      ...prev,
      sample: newSample,
      imp_l15: Math.round(!useSpecialSum ? sumOfField(newSample, "l15") : sumOfField(newSample, "ltt") * (newSample || "")[0]?.vcf),
    }));
  };
  const handleClick = () => {
    //saving
    if (isEdit) {
      return saveKT0406(localData.id, {
        transaction_id: ticketid,
        date: moment(localData.date || Date.now()).format("YYYY-MM-DD HH:mm"),
        receiver: localData.receiver,
        senior_receiver: localData.senior_receiver,
        barem: localData.barem,
        barem_date: moment(localData.barem_date || Date.now()).format("YYYY-MM-DD"),
        impdate: moment(localData.impdate || Date.now()).format("YYYY-MM-DD HH:mm"),
        stability_duration: localData.stability_duration,
        exam_duration: localData.exam_duration,
        start_pump: moment(localData.start_pump || Date.now()).format("YYYY-MM-DD HH:mm"),
        end_pump: moment(localData.end_pump || Date.now()).format("YYYY-MM-DD HH:mm"),
        density: localData.density,
        temperature: localData.temperature,
        d15: localData.d15,
        vcf: localData.vcf,
        imp_lit: sumOfField(localData.sample, "ltt"),
        imp_l15: localData.imp_l15,
        imp_kg: Math.round(sumOfField(localData.sample, "kg")),
        imp_wcf: parseFloat(sumOfField(localData.sample, "wcf") / localData.sample.length).toFixed(4),
        imp_vcf: parseFloat(sumOfField(localData.sample, "vcf") / localData.sample.length).toFixed(4),
        imp_temp: parseFloat(sumOfField(localData.sample, "temperature") / localData.sample.length).toFixed(2),
        gap_l15: localData.imp_l15 - localData.exp_l15,
        sample: localData.sample,
        conclusion: localData.conclusion,
        chemist: localData.chemist,
        chemist_approve: localData.chemist_approve,
        imp_tank_id: localData.imp_tank?.id || null,
      });
    }
    //editing
    else return setIsEdit(true);
  };
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      setIsEdit(false);
      onUpdateSuccess && onUpdateSuccess();
    }
  };
  useLayoutEffect(() => {
    setLocalData({ ...data, sample: JSON.parse(data.sample) });
  }, [data]);
  useLayoutEffect(() => {
    if (!isEdit) return;
    if (!data.date) handleChange("date", Date.now());
    if (!data.impdate) handleChange("impdate", moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"));
    if (!data.start_pump) handleChange("start_pump", moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"));
    if (!data.end_pump) handleChange("end_pump", moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);
  useLayoutEffect(() => {
    if (!localData || typeof localData.d15 === "number") return;
    localData.sample.forEach((item, index) => editSample(index, "temperature", item.temperature));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localData.d15]);
  if (localData)
    return (
      <div align="center">
        <div ref={printRef} style={{ minWidth: 794, minHeight: 1123, width: 794, margin: "auto", padding: "30px 50px", wordwrap: "break-word" }}>
          <style type="text/css" media="print">
            {" @page { size: A4 portrait; } "}
          </style>
          <div style={{ height: 130, display: "flex", border: "1px solid gray" }}>
            <div style={{ width: "35%", display: "flex", padding: 5 }}>
              <img alt="" style={{ margin: "auto", width: "100%", height: 46, objectFit: "contain" }} src="/logoP3.png" />
            </div>
            <div style={{ width: "40%", borderLeft: "1px solid gray" }}>
              <div style={{ height: "40%" }} align="center">
                <b>
                  CÔNG TY CỔ PHẦN NHIÊN LIỆU BAY
                  <br /> PETROLIMEX
                </b>
              </div>
              <div style={{ borderTop: "1px solid gray", display: "flex", height: "60%" }} align="center">
                <div style={{ margin: "auto" }}>
                  <b>
                    BIÊN BẢN GIÁM ĐỊNH SỐ LƯỢNG
                    <br /> NHẬP HÀNG ĐƯỜNG BỘ
                  </b>
                </div>
              </div>
            </div>
            <div align="left" style={{ width: "25%", borderLeft: "1px solid gray", paddingLeft: 10 }}>
              Mã số: <br />
              {localData.code}
              <br />
              Lần ban hành: {localData.version}
              <br />
              Ngày hiệu lực:
              <br /> {moment(localData.effective_date).format("DD/MM/YYYY")}
            </div>
          </div>
          <div style={{ padding: "10px 0 30px 40px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <b>1.</b> Thời gian:{" "}
                {isEdit ? (
                  <CustomDatePicker
                    slotProps={{ textField: { variant: "standard" } }}
                    value={moment(localData.date || Date.now()).format("YYYY-MM-DD")}
                    onChange={(value) => handleChange("date", value)}
                  />
                ) : (
                  localData.date && moment(localData.date).format("DD/MM/YYYY")
                )}
              </div>
              <p>Số phiếu {localData.form_code} </p>
            </div>
            <div align="left">
              <b>2.</b> Thành phần:
            </div>
            <div align="left" style={{ paddingLeft: 20, display: "grid", gridTemplateColumns: "40% 60%" }}>
              <div>
                a/{isEdit ? <TextField variant="standard" value={localData.receiver || ""} onChange={(e) => handleChange("receiver", e.target.value)} /> : localData.receiver}
                <br />
                b/{localData.driver}
                <br />
                c/{isEdit ? <TextField variant="standard" value={localData.senior_receiver || ""} onChange={(e) => handleChange("senior_receiver", e.target.value)} /> : localData.senior_receiver}
              </div>
              <div>
                Giao nhân viên
                <br />
                Đại diện phương tiện
                <br />
                Đội giao nhận
                <br />
              </div>
            </div>
            <div align="left">
              <b>3.</b> Giám định tại phương tiện:
              <div style={{ paddingLeft: 20 }}>
                <div style={{ display: "grid", gridTemplateColumns: "60% 40%" }}>
                  <div>
                    Số xe: <b>{localData.vehicle}</b>&nbsp;&nbsp;&nbsp;Barem số:{" "}
                    {isEdit ? <TextField variant="standard" value={localData.barem || ""} onChange={(e) => handleChange("barem", e.target.value)} /> : localData.barem}
                    <br />
                    Số hóa đơn: {localData.transaction_code}
                  </div>
                  <div>
                    Lập ngày:{" "}
                    {isEdit ? (
                      <CustomDatePicker
                        slotProps={{ textField: { variant: "standard" } }}
                        sx={{ maxWidth: 150 }}
                        value={moment(localData.barem_date || Date.now()).format("YYYY-MM-DD")}
                        onChange={(value) => handleChange("barem_date", moment(value).format("YYYY-MM-DD"))}
                      />
                    ) : (
                      localData.barem_date && moment(localData.barem_date).format("DD/MM/YYYY")
                    )}
                    <br />
                    Số chứng chỉ: {localData.certificate}
                  </div>
                </div>
                <div>- Thời gian nhập hàng:</div>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        {/* <TableCell align='center' padding='checkbox' style={{ border: '1px solid gray', borderBottom: 'white' }}>Thời gian</TableCell> */}
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          Đến chi nhánh
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray", display: isHydrant ? "none" : "" }}>
                          Ổn định (phút)
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray", display: isHydrant ? "none" : "" }}>
                          Kiểm tra mẫu (phút)
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          Bắt đầu bơm
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          Kết thúc bơm
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {/* <TableCell align='center' padding='checkbox' style={{ border: '1px solid gray', borderTop: '' }}>&nbsp;</TableCell> */}
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          {isEdit ? (
                            <CustomDatePicker
                              slotProps={{ textField: { variant: "standard" } }}
                              sx={{ minWidth: 180 }}
                              format="DD/MM/YYYY HH:mm"
                              outputFormat="YYYY-MM-DD HH:mm"
                              value={moment(localData.impdate).format("YYYY-MM-DD[T]HH:mm")}
                              onChange={(value) => handleChange("impdate", value)}
                            />
                          ) : (
                            localData.impdate && moment(localData.impdate).format("DD/MM/YYYY HH:mm")
                          )}{" "}
                          <br />
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray", display: isHydrant ? "none" : "" }}>
                          {isEdit ? (
                            <TextField
                              variant="standard"
                              type="number"
                              inputProps={{ style: { width: 100, textAlign: "center" } }}
                              value={localData.stability_duration || ""}
                              onChange={(e) => handleChange("stability_duration", e.target.value)}
                            />
                          ) : (
                            localData.stability_duration
                          )}
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray", display: isHydrant ? "none" : "" }}>
                          {isEdit ? (
                            <TextField
                              variant="standard"
                              type="number"
                              inputProps={{ style: { width: 100, textAlign: "center" } }}
                              value={localData.exam_duration || ""}
                              onChange={(e) => handleChange("exam_duration", e.target.value)}
                            />
                          ) : (
                            localData.exam_duration
                          )}
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          {isEdit ? (
                            <CustomDatePicker
                              slotProps={{ textField: { variant: "standard" } }}
                              sx={{ minWidth: 180 }}
                              format="DD/MM/YYYY HH:mm"
                              outputFormat="YYYY-MM-DD HH:mm"
                              value={moment(localData.start_pump).format("YYYY-MM-DD[T]HH:mm")}
                              onChange={(value) => handleChange("start_pump", value)}
                            />
                          ) : (
                            localData.start_pump && moment(localData.start_pump).format("DD/MM/YYYY HH:mm")
                          )}
                        </TableCell>
                        <TableCell align="center" padding="checkbox" style={{ border: "1px solid gray" }}>
                          {isEdit ? (
                            <CustomDatePicker
                              slotProps={{ textField: { variant: "standard" } }}
                              sx={{ minWidth: 180 }}
                              format="DD/MM/YYYY HH:mm"
                              outputFormat="YYYY-MM-DD HH:mm"
                              value={moment(localData.end_pump).format("YYYY-MM-DD[T]HH:mm")}
                              onChange={(value) => handleChange("end_pump", value)}
                            />
                          ) : (
                            localData.end_pump && moment(localData.end_pump).format("DD/MM/YYYY HH:mm")
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <div>- Giám định số lượng trước khi nhập hàng:</div>
                <div>
                  {isHydrant && (
                    <>
                      +/ Nhập vào bể: &nbsp;
                      <div style={{ display: isEdit ? "inline-flex" : "none" }}>
                        <FilterBy
                          style={{ display: "inline-flex", minWidth: 200 }}
                          variant="standard"
                          placeholder={"Bồn"}
                          getDataFunc={() => getTank({ inventory_id: ticketData?.receipt.to_inventory_id })}
                          getOptionLabel={(option) => `${option.id} - ${option.code}`}
                          value={localData.imp_tank || null}
                          onChange={(e, newvalue) => handleChange("imp_tank", newvalue)}
                          setDefaultFunc={(option) =>
                            handleChange(
                              "imp_tank",
                              // eslint-disable-next-line eqeqeq
                              option.find((item) => item.id == ticketData.receipt.imp_tank_ids)
                            )
                          }
                          triggerSetDefaultFunc={Boolean(ticketData)}
                          setDefaultDependencies={[ticketData.receipt.imp_tank_ids, data]}
                        />
                      </div>
                      <div style={{ display: !isEdit ? "inline-flex" : "none" }}>{localData?.imp_tank?.code}</div>
                    </>
                  )}
                </div>
                +/ Khối lượng riêng quy chuẩn (D15) nhiên liệu trên xe xitec:{" "}
                {isEdit && isHydrant ? (
                  <TextField variant="standard" type="number" placeholder="0.7010 - 0.8730" value={localData.d15 || ""} onChange={(e) => handleChange("d15", e.target.value)} />
                ) : (
                  localData.d15 && parseFloat(localData.d15).toFixed(4)
                )}
                <br />
                +/ Số lượng giám định cụ thể:
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Hầm số
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Dung tích kiểm định (Lít)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Chiều cao mức dầu (mm)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Nhiệt độ dầu (℃)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          VCF
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Vtt (Lít)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          V15 tại CN (Lít/15)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          V15 tại Kho xuất (Lít/15)
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                          Chênh lệch
                        </TableCell>
                        {isHydrant && (
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            WCF
                          </TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {localData.sample.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {item.id}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {Math.round(item.lit)?.toLocaleString()}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {isEdit ? (
                              <TextField
                                variant="standard"
                                inputProps={{ style: { textAlign: "center", minWidth: 100 } }}
                                type="number"
                                value={item.height || ""}
                                onChange={(e) => editSample(index, "height", e.target.value)}
                              />
                            ) : (
                              item.height
                            )}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {isEdit ? (
                              <TextField
                                variant="standard"
                                placeholder="4.5 - 52"
                                error={item.temperature && (item.temperature > 52 || item.temperature < 4.5)}
                                inputProps={{ style: { textAlign: "center", minWidth: 100 } }}
                                type="number"
                                value={item.temperature || ""}
                                onChange={(e) => editSample(index, "temperature", e.target.value)}
                              />
                            ) : (
                              item.temperature && parseFloat(item.temperature)?.toFixed(2)
                            )}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {isEdit && isHydrant ? (
                              <TextField
                                type="number"
                                variant="standard"
                                inputProps={{ style: { textAlign: "center", minWidth: 100 } }}
                                value={item.vcf || ""}
                                onChange={(e) => editSample(index, "vcf", e.target.value)}
                              />
                            ) : (
                              item.vcf && parseFloat(item.vcf).toFixed(4)
                            )}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {item.ltt ? Math.round(item.ltt).toLocaleString() : ""}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                            {item.l15 ? Math.round(item.l15).toLocaleString() : ""}
                          </TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox"></TableCell>
                          <TableCell style={{ border: "1px solid gray" }} padding="checkbox"></TableCell>
                          {isHydrant && (
                            <TableCell style={{ border: "1px solid gray" }} padding="checkbox">
                              {item.wcf}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox" colSpan={5}>
                          Tổng cộng
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox" align="center">
                          {Math.round(sumOfField(localData.sample, "ltt"))?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox" align="center">
                          {localData.imp_l15?.toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox" align="center">
                          {Math.round(localData.exp_l15).toLocaleString()}
                        </TableCell>
                        <TableCell style={{ border: "1px solid gray" }} padding="checkbox" align="center">
                          {(localData.imp_l15 - localData.exp_l15).toLocaleString()}
                        </TableCell>
                        {isHydrant && <TableCell style={{ border: "1px solid gray" }} padding="checkbox"></TableCell>}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <br />
              {/* <b>4. Kết luận:</b> {isEdit ? <TextField variant='standard' style={{width: 500}} value={localData.conclusion} onChange={e => handleChange('conclusion', e.target.value)}/> : localData.conclusion} */}
              {isEdit ? (
                <TextField
                  variant="standard"
                  label="4. Kết luận:"
                  size="small"
                  fullWidth
                  style={{ margin: "10px 0" }}
                  value={localData.conclusion || ""}
                  onChange={(e) => handleChange("conclusion", e.target.value)}
                />
              ) : (
                `4. Kết luận: ${Boolean(localData.conclusion) ? localData.conclusion : ""}`
              )}
              <br />
            </div>
            {/* signing place */}
            <div style={{ display: "grid", gridTemplateColumns: "40% 30% 30%", marginTop: 20, height: 150 }}>
              <div align="center" style={{ maxHeight: 150 }}>
                <b style={{ display: "block" }}>NHÂN VIÊN GIAO NHẬN</b>
                <img width="100%" height={Boolean(localData.receiver_sign) ? "" : 0} style={{ objectFit: "contain", maxHeight: 150 }} src={localData.receiver_sign} alt="" />
              </div>
              <div align="center" style={{ maxHeight: 150 }}>
                <b style={{ display: "block" }}>ĐỘI GIAO NHẬN</b>
                <img width="100%" height={Boolean(localData.senior_receiver_sign) ? "" : 0} style={{ objectFit: "contain", maxHeight: 150 }} src={localData.senior_receiver_sign} alt="" />
              </div>
              <div align="center" style={{ maxHeight: 150 }}>
                <b style={{ display: "block" }}>LÁI XE</b>
                <img width="100%" height={Boolean(localData.driver_sign) ? "" : 0} style={{ objectFit: "contain", maxHeight: 150 }} src={localData.driver_sign} alt="" />
              </div>
            </div>
          </div>
          <div align="left" style={{ border: "1px solid gray", marginLeft: 30, paddingLeft: 10, display: "flex", justifyContent: "space-between" }}>
            <div>
              <br />
              Ý kiến của hóa nghiệm viên:
              <br />
              <div>
                - Đạt, chấp thuận cho phép nhập hàng vào kho:{" "}
                <Checkbox onClick={() => handleChange("chemist_approve", !localData.chemist_approve)} disabled={!isEdit} checked={Boolean(localData.chemist_approve)} />
              </div>
              <div>
                - Không đạt: <Checkbox onClick={() => handleChange("chemist_approve", !localData.chemist_approve)} disabled={!isEdit} checked={!localData.chemist_approve} />
              </div>
              - Ký tên.................................
            </div>
            <div style={{ width: "40%" }}>
              <img height={Boolean(localData.chemist_sign) ? "" : 0} src={localData.chemist_sign} alt="" width="100%" style={{ objectFit: "contain", maxHeight: 200 }} />
            </div>
          </div>
        </div>
        <ButtonWithAPICall disabled={!editable} variant="outlined" api={handleClick} response={handleSaveResponse}>
          {!isEdit ? "Chỉnh sửa" : "Lưu"}
        </ButtonWithAPICall>
      </div>
    );
  else return "";
}

export function BMQTKT0407({ data, printRef, onUpdateSuccess, ticketData }) {
  //form BM.QT.KT.04.07
  const [isEdit, setIsEdit] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [localData, setLocalData] = useState("");
  const handleChange = (keyName, value) => {
    setLocalData((prev) => ({ ...prev, [keyName]: value }));
  };
  const handleChangeVTankChecked = (index, keyName, value) => {
    handleChange(
      "vtank_checked",
      JSON.stringify(
        JSON.parse(localData.vtank_checked).filter((item, sub_index) => {
          let newItem = item;
          if (index === sub_index) newItem[keyName] = value;
          return newItem;
        })
      )
    );
  };
  //test loading
  const [isSaving, setIsSaving] = useState(false);

  const handleClick = () => {
    //saving
    if (isEdit) {
      setIsSaving(true);
      saveKT0407(localData.id, {
        date: moment(localData.date || Date.now()).format("YYYY-MM-DD HH:mm"),
        vehicle_reg: localData.vehicle_reg,
        driver_lic: localData.driver_lic,
        entrance_reg: localData.entrance_reg,
        driver_protection: localData.driver_protection,
        fueltransport_lic: localData.fueltransport_lic,
        fire_protection_equip: localData.fire_protection_equip,
        ei_1542_sign: localData.ei_1542_sign,
        seals: localData.seals,
        vehicle_cert: localData.vehicle_cert,
        seal_from: localData.seal_from,
        seal_to: localData.seal_to,
        custody_items: localData.custody_items,
        vtank1_from: localData.vtank1_from,
        vtank1_to: localData.vtank1_to,
        vtank2_from: localData.vtank2_from,
        vtank2_to: localData.vtank2_to,
        vtank_checked: localData.vtank_checked,
        note: localData.note,
        conclusion: localData.conclusion,
      }).then((res) => {
        if (res.code === 200) {
          setIsEdit(false);
          onUpdateSuccess && onUpdateSuccess();
        }
        setIsSaving(false);
        enqueueSnackbar(res.message, { variant: res.code === 200 ? "success" : "" });
      });
    }
    //editing
    else setIsEdit(true);
  };
  useEffect(() => {
    setLocalData(data);
  }, [data]);

  if (localData)
    return (
      <div>
        <div ref={printRef} style={{ minWidth: 794, minHeight: 1123, width: 794, height: 1123, margin: "auto", padding: "30px 50px", wordWrap: "break-word" }}>
          <div style={{ height: 100, display: "flex", border: "1px solid gray" }}>
            <div style={{ width: "35%", display: "flex" }}>
              <img alt="" style={{ margin: "auto", width: "100%", height: 46, objectFit: "contain" }} src="/logoP3.png" />
            </div>
            <div style={{ width: "40%", borderLeft: "1px solid gray", display: "flex" }}>
              <div style={{ height: "40%", margin: "auto" }} align="center">
                <b>BIÊN BẢN GIÁM SÁT PHƯƠNG TIỆN NHẬP HÀNG</b>
              </div>
            </div>
            <div align="left" style={{ width: "25%", borderLeft: "1px solid gray", paddingLeft: 10 }}>
              Mã số:
              <br />
              {localData.code}
              <br />
              Lần ban hành: {localData.version}
              <br />
              Ngày hiệu lực: {moment(localData.effective_date).format("DD/MM/YYYY")}
            </div>
          </div>
          <div align="left">
            <br />
            1. Thời gian:{" "}
            {isEdit ? (
              <CustomDatePicker
                slotProps={{ textField: { variant: "standard" } }}
                format="DD/MM/YYYY HH:mm"
                outputFormat="YYYY-MM-DD HH:mm"
                value={moment(localData.date || Date.now()).format("YYYY-MM-DD[T]HH:mm")}
                onChange={(value) => handleChange("date", value)}
              />
            ) : (
              localData.date && moment(localData.date).format("DD/MM/YYYY")
            )}
            <br />
            2. Tên phương tiện: {localData.vehicle}
            <br />
            3. Kiểm tra phương tiện trước khi vào Chi nhánh:
            <br />
            <div style={{ paddingLeft: 17 }}>
              Phương tiện đảm bảo các yêu cầu:
              <TableContainer style={{ marginBottom: 10 }}>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Giấy đăng kí xe
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("vehicle_reg", localData.vehicle_reg ? 0 : 1)} checked={Boolean(localData.vehicle_reg)} />
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Giấy phép ra vào nội bộ của phương tiện và lái xe
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("entrance_reg", localData.entrance_reg ? 0 : 1)} checked={Boolean(localData.entrance_reg)} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Giấy phép lái xe của lái xe
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("driver_lic", localData.driver_lic ? 0 : 1)} checked={Boolean(localData.driver_lic)} />
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Lái xe trang bị đầy đủ bảo hộ lao động theo quy định
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("driver_protection", localData.driver_protection ? 0 : 1)} checked={Boolean(localData.driver_protection)} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Giấy phép vận chuyển nhiên liệu dễ cháy nổ
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("fueltransport_lic", localData.fueltransport_lic ? 0 : 1)} checked={Boolean(localData.fueltransport_lic)} />
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Trang thiết bị chữa cháy đầy đủ và đảm bảo
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox
                          disabled={!isEdit}
                          onChange={() => handleChange("fire_protection_equip", localData.fire_protection_equip ? 0 : 1)}
                          checked={Boolean(localData.fire_protection_equip)}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Đánh dấu chủng loại nhiên liệu theo EI 1542 của xe
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("ei_1542_sign", localData.ei_1542_sign ? 0 : 1)} checked={Boolean(localData.ei_1542_sign)} />
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Tất cả các niêm phong còn nguyên vẹn và đúng theo biên bản niêm
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("seals", localData.seals ? 0 : 1)} checked={Boolean(localData.seals)} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Giấy đăng kí và đăng kiểm của phương tiện
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={!isEdit} onChange={() => handleChange("vehicle_cert", localData.vehicle_cert ? 0 : 1)} checked={Boolean(localData.vehicle_cert)} />
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="40%">
                        Số niêm:{" "}
                        {isEdit ? (
                          <TextField variant="standard" style={{ width: "auto" }} value={localData.seal_from || ""} onChange={(e) => handleChange("seal_from", e.target.value)} />
                        ) : (
                          localData.seal_from
                        )}
                      </TableCell>
                      <TableCell align="left" style={{ border: "1px solid gray" }} width="10%">
                        <Checkbox disabled={true} checked={Boolean(localData.seal_from)} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={{ border: "1px solid gray" }} colSpan={4} width="100%">
                        {/* {isEdit ? <TextField variant='standard' value={localData.custody_items} onChange={e => handleChange('custody_items', e.target.value)}/> : localData.custody_items} */}
                        {isEdit ? (
                          <TextField
                            variant="standard"
                            label="Các vật tạm giữ từ phương tiện và lái xe:"
                            size="small"
                            fullWidth
                            style={{ margin: "10px 0" }}
                            value={localData.custody_items || ""}
                            onChange={(e) => handleChange("custody_items", e.target.value)}
                          />
                        ) : (
                          `Các vật tạm giữ từ phương tiện và lái xe: ${Boolean(localData.custody_items) ? localData.custody_items : ""}`
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={{ display: "flex", marginBottom: 10, width: "100%" }}>
              <div style={{ minWidth: "45%" }}>4. Mức nhiên liệu trong két dầu phương tiện:&nbsp;</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", width: "100%" }}>
                <div>
                  Két 1: trước{" "}
                  {isEdit ? (
                    <TextField variant="standard" style={{ width: 100 }} type="number" value={localData.vtank1_from || ""} onChange={(e) => handleChange("vtank1_from", e.target.value)} />
                  ) : (
                    localData.vtank1_from
                  )}{" "}
                  <br />
                  Két 2: trước{" "}
                  {isEdit ? (
                    <TextField variant="standard" style={{ width: 100 }} type="number" value={localData.vtank2_from || ""} onChange={(e) => handleChange("vtank2_from", e.target.value)} />
                  ) : (
                    localData.vtank2_from
                  )}
                </div>
                <div>
                  sau:{" "}
                  {isEdit ? (
                    <TextField variant="standard" style={{ width: 100 }} type="number" value={localData.vtank1_to || ""} onChange={(e) => handleChange("vtank1_to", e.target.value)} />
                  ) : (
                    localData.vtank1_to
                  )}{" "}
                  <br />
                  sau:{" "}
                  {isEdit ? (
                    <TextField variant="standard" style={{ width: 100 }} type="number" value={localData.vtank2_to || ""} onChange={(e) => handleChange("vtank2_to", e.target.value)} />
                  ) : (
                    localData.vtank2_to
                  )}
                </div>
              </div>
            </div>
            5. Kết quả kiểm tra khám khô hầm hàng sau khi nhập hàng :
            <div style={{ paddingLeft: 20 }}>
              {localData.vtank_checked &&
                JSON.parse(localData.vtank_checked).map((item, index) => (
                  <div key={item.id}>
                    Lần {item.id}: Khô sạch:
                    <Checkbox disabled={!isEdit} onChange={() => handleChangeVTankChecked(index, "clean", item.clean === null ? 1 : item.clean === 1 ? null : 1)} checked={item.clean === 1} />
                    &nbsp; &nbsp; &nbsp; &nbsp;Còn hàng:
                    <Checkbox disabled={!isEdit} onChange={() => handleChangeVTankChecked(index, "clean", item.clean === null ? 0 : item.clean === 0 ? null : 0)} checked={item.clean === 0} />
                    &nbsp; &nbsp; &nbsp; &nbsp; Lượng nhiên liệu chắt vét{" "}
                    {isEdit ? (
                      <TextField variant="standard" style={{ width: 100 }} value={item.lit || ""} onChange={(e) => handleChangeVTankChecked(index, "lit", e.target.value)} />
                    ) : (
                      item.lit || "......"
                    )}{" "}
                    Lít
                    <br />
                  </div>
                ))}
            </div>
            {isEdit ? (
              <TextField
                variant="standard"
                label="6. Báo cáo tình huống bất thường:"
                size="small"
                fullWidth
                style={{ margin: "10px 0" }}
                value={localData.note || ""}
                onChange={(e) => handleChange("note", e.target.value)}
              />
            ) : (
              `6. Báo cáo tình huống bất thường: ${Boolean(localData.note) ? localData.note : ""}`
            )}
            <br />
            {/* 7. Kết luận: {isEdit ?  <TextField variant='standard' value={localData.conclusion} onChange={e => handleChange('conclusion', e.target.value)}/> : localData.conclusion}<br/><br/> */}
            {isEdit ? (
              <TextField
                variant="standard"
                label="7. Kết luận:"
                size="small"
                fullWidth
                style={{ margin: "10px 0" }}
                value={localData.conclusion || ""}
                onChange={(e) => handleChange("conclusion", e.target.value)}
              />
            ) : (
              `7. Kết luận: ${Boolean(localData.conclusion) ? localData.conclusion : ""}`
            )}
            <br />
          </div>
          {/* signing */}
          <div style={{ display: "grid", gridTemplateColumns: "40% 30% 30%", marginTop: 20, height: 150 }}>
            <div align="center" style={{ maxHeight: 150 }}>
              <b style={{ display: "block" }}>NHÂN VIÊN GIAO NHẬN</b>
              <img src={localData.receiver_sign} alt="" width="100%" style={{ objectFit: "contain", maxHeight: 150 }} />
            </div>
            <div align="center" style={{ maxHeight: 150 }}>
              <b style={{ display: "block" }}>BẢO VỆ</b>
              <img src={localData.guard_sign} alt="" width="100%" style={{ objectFit: "contain", maxHeight: 150 }} />
            </div>
            <div align="center" style={{ maxHeight: 150 }}>
              <b style={{ display: "block" }}>LÁI XE</b>
              <img src={localData.driver_sign} alt="" width="100%" style={{ objectFit: "contain", maxHeight: 150 }} />
            </div>
          </div>
        </div>
        <Button variant="outlined" disabled={isSaving} onClick={handleClick}>
          {!isEdit ? "Chỉnh sửa" : "Lưu"}
        </Button>
      </div>
    );
  else return "";
}
